'use client'

import { useTranslations } from 'next-intl'

import { useRouter } from '@/shared/i18n'
import { Button, Icon } from '@/shared/ui'

type Props = {
  returnTo: string
  totalElements: number
  keyword?: string
}

export const SearchResult = ({
  returnTo,
  totalElements,
  keyword = '',
}: Props) => {
  const router = useRouter()

  const t = useTranslations('faq')

  const handleReturnToList = () => {
    router.push(returnTo)
  }

  return (
    <div className="mb-5 border-b border-b-black pb-5">
      <div className="flex items-center justify-between">
        <div className="typo-title3 flex items-center gap-3 font-semibold text-black">
          {t('search_result.title')}
          <span className="typo-headline1 text-purple-500">
            {totalElements}
          </span>
        </div>
        <Button size="small" variant="outline" onClick={handleReturnToList}>
          <Icon name="arrow-left" size={16} />
          {t('search_result.button.back_to_list')}
        </Button>
      </div>
      <p className="typo-label2 mt-2 flex gap-1 text-gray-900">
        {t.rich('search_result.description', {
          keyword,
          highlight: chunks => (
            <span className="font-medium text-purple-500">{chunks}</span>
          ),
        })}
      </p>
    </div>
  )
}
